import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { getContacts } from "../../services/SharedServices";
import moment from "moment";

export default function ContactsList() {
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await getContacts({
        token: "",
      });
      setContacts(response.data.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs title="Contactos" breadcrumbItem="Contactos" />

        <Row>
          <Col>
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0">
                <Table className="table table-striped table-bordered">
                  <Thead>
                    <Tr>
                      <Th>#</Th>
                      <Th>Fecha</Th>
                      <Th>Nombre</Th>
                      <Th>Email</Th>
                      <Th>Celular</Th>
                      <Th>Mensaje</Th>
                      <Th>Operación</Th>
                      <Th>Propiedad URL</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {contacts.map((item: any) => (
                      <Tr>
                        <Th>{item.id}</Th>
                        <Th>{moment(item.send_date).format("DD/MM/YYYY")}</Th>
                        <Th>{item.name}</Th>
                        <Th>{item.email}</Th>
                        <Th>{item.phone}</Th>
                        <Th>{item.message}</Th>
                        <Th>{item.operation}</Th>
                        <Th>
                          <a href={item.property_id} target="_blank">
                            {item.property_id}
                          </a>
                        </Th>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
